'use client';

import { signOut } from '@repo/auth';
import { useEffect, useRef } from 'react';

export function ClearStaleCookies(): null {
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) {
      return;
    }
    hasRun.current = true;

    void signOut({
      fetchOptions: {
        onSuccess: () => {
          // Cookies cleared - user can now retry login
        },
      },
    }).catch(() => {
      // Best-effort cleanup - silently ignore errors
    });
  }, []);

  return null;
}
